import { FeatureCollection, Geometry } from 'geojson';

export interface MapboxMapStyle {
  id: string;
  styleId: string;
  search: RegExp;
  label: string;
  icon: string;
}

export const mapboxMapStyles: MapboxMapStyle[] = [{
  id: 'streets-v12',
  styleId: 'streets',
  label: 'Streets',
  search: /^streets\-v/,
  icon: '/assets/imgs/mapbox-streets-preview.png'
}, {
  id: 'satellite-v9',
  styleId: 'satellite',
  label: 'Satellite',
  search: /^satellite\-v/,
  icon: '/assets/imgs/mapbox-satellite-preview.jpeg'
}, {
  id: 'satellite-streets-v12',
  styleId: 'satellite-streets',
  label: 'Sat/Streets',
  search: /^satellite\-streets\-v/,
  icon: '/assets/imgs/mapbox-satellite-streets-preview.jpeg'
}, {
  id: 'outdoors-v12',
  styleId: 'outdoors',
  label: 'Outdoors',
  search: /^outdoors\-v/,
  icon: '/assets/imgs/mapbox-outdoors-preview.png'
}, {
  id: 'bing',
  styleId: 'bing',
  label: 'Bing',
  search: /^bing/,
  icon: '/assets/imgs/bing-maps-preview.png'
}];

export type MapboxMapStyleId = typeof mapboxMapStyles[number]['id'];

export const matchMapboxStyleId = (styleId: string): MapboxMapStyleId => {
  for (const m of mapboxMapStyles) {
    if (m.search.test(styleId)) {
      return m.id;
    }
  }
  return null;
}

export const mapboxMapStyleUrl = (id: MapboxMapStyleId): string => `mapbox://styles/mapbox/${id}?optimize=true`;
export const mapboxMapStyleById = (id: MapboxMapStyleId): MapboxMapStyle => mapboxMapStyles.find(a => a.id === id);


export const emptyFeatureCollection = <T extends Geometry, P = { [name: string]: any }>(): FeatureCollection<T, P> => ({
  type: 'FeatureCollection',
  features: []
});

